import http from '@core/fetch'

// 获取材料颜色
export const getMaterialsColor = path => {
  return http(`${path}?vframe/jpg/offset/1|imageAve`, {
    dataType: 'json',
    credentials: 'omit',
    headers: {}
  })
}
